import React from "react";

const CreditScoreList = React.lazy(() => import('src/pages/credit_score/CreditScoreList'));

const routes = [
    { path: '/dashboard/credit-score-list', name: 'Credit Score', element: CreditScoreList },
];

export default routes;
